"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  set: function set(name, value, days) {
    var expires;

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=\"".concat(date.toUTCString());
    }

    document.cookie = "".concat(name, "=").concat(value || '').concat(expires, "\"; path=/");
  },
  get: function get(name) {
    var cookie = document.cookie.split(';');

    for (var i = 0; i < cookie.length; i += 1) {
      if (cookie[i].indexOf(name) > -1) {
        return cookie[i].substring(cookie[i].indexOf('=') + 1, cookie[i].length).toString();
      }
    }

    return null;
  }
};
exports["default"] = _default;